import React, { ReactNode, useState } from "react";

function ContentCompressor({
  children,
  isMobile,
}: {
  children: ReactNode;
  isMobile: boolean;
}) {
  const [showMore, setShowMore] = useState(false);

  return !showMore && isMobile ? (
    <div className="relative h-[388px] overflow-hidden">
      {children}
      <div className="bg-curtain-gradient absolute top-0 flex size-full items-end justify-center">
        <span
          className="text-brand-primary mb-5 text-xs font-bold"
          onClick={() => {
            setShowMore(true);
          }}
        >
          Show more
        </span>
      </div>
    </div>
  ) : (
    <>{children}</>
  );
}

export default ContentCompressor;
